import {Mapper} from '@s-ui/domain'

export default class articleJSONToArticleEntityMapper extends Mapper {
  constructor({config, articleEntityFactory, articleImageEntityFactory, tagEntityFactory}) {
    super()
    this._config = config
    this._articleImageEntityFactory = articleImageEntityFactory
    this._articleEntityFactory = articleEntityFactory
    this._tagEntityFactory = tagEntityFactory
    this._relTag = this._config.get('seo').SPONSORED_REL_TAG
    this._urlTagPath = this._config.get('page').NEWS_TAG_PATH_PATTERN
  }

  _generateTagLink = tagName => this._urlTagPath.replace(':tag', tagName)

  map = article =>
    this._articleEntityFactory({
      config: this._config,
      id: article.id,
      img: this._articleImageEntityFactory({
        url: article.imageUrl,
        cutCoordinates: article.cutCoordinates
      }),
      tag:
        article.tag &&
        this._tagEntityFactory({
          id: article.tag.path,
          url: this._generateTagLink(article.tag.path),
          text: article.tag.text,
          rel: this._relTag
        }),
      numComments: article.numComments,
      commentsDisabled: article.commentsDisabled,
      description: article.description,
      url: article.url,
      title: article.title,
      isVideo: article.isVideo,
      shouldUseCommentsPage:
        !this._config.get('isMobile') || this._config.get('editorial').HAS_MOBILE_COMMENTS_PAGE_ENABLED
    })
}
